import { articles, type ArticleItem } from '@/mocks/articles';
import { categories, type CategoryItem } from '@/mocks/categories';

export const getCategoryBySlug = (slug: string): CategoryItem | undefined =>
  categories.find((item) => item.slug === slug);

export const getCategoryName = (slug: string): string => {
  const found = categories.find((item) => item.slug === slug);
  return found ? found.name : '未分类';
};

export const getArticlesByCategory = (slug: string): ArticleItem[] =>
  articles.filter((item) => item.categorySlug === slug);

export const getArticleById = (id: string): ArticleItem | undefined =>
  articles.find((item) => item.id === id);

export const getLatestArticles = (limit?: number): ArticleItem[] => {
  const sorted = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1));
  return typeof limit === 'number' ? sorted.slice(0, limit) : sorted;
};

export const getHotArticles = (limit: number): ArticleItem[] =>
  [...articles].sort((a, b) => b.hot - a.hot).slice(0, limit);

export const getLiveArticles = (limit: number): ArticleItem[] =>
  articles.filter((item) => item.isLive).slice(0, limit);

export const getRelatedArticles = (current: ArticleItem, limit: number): ArticleItem[] => {
  const sameCategory = articles.filter(
    (item) => item.id !== current.id && item.categorySlug === current.categorySlug,
  );
  const others = articles.filter(
    (item) => item.id !== current.id && item.categorySlug !== current.categorySlug,
  );
  return [...sameCategory, ...others].slice(0, limit);
};

export const getAdjacentArticles = (
  current: ArticleItem,
): { prev?: ArticleItem; next?: ArticleItem } => {
  const index = articles.findIndex((item) => item.id === current.id);
  if (index < 0) return {};
  return {
    prev: articles[index - 1],
    next: articles[index + 1],
  };
};

export const buildCanonical = (path: string): string => {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const base = (__BASE_PATH__ || '/').replace(/\/$/, '');
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${origin}${base}${clean}`;
};